<template>
    <el-row style="max-height: 65vh;overflow-x: hidden;overflow-y: auto" v-loading="!is_ok">
        <!-- 对账单 -->
        <el-col :span="24">
            <div class="table-title_two" style="margin-bottom: 3%;">
                <div>
                    <img
                        style="width: 150px; height: 118px;border-radius:10px;"
                    :src="require('../../assets/img/lng.png')"
                    />
                </div>
            </div>
            <div class="table-title" style="margin-bottom: 3%;">
                <div style="display: flex;align-items: center;">
                    <span class="bill_title">陕西靖边星源实业有限公司LNG对账单</span>
                </div>
            </div>
            <div class="boxLine"></div>
        </el-col>
        <el-col :span="24">
            <div  style="margin: 1% 2%;font-weight: bold;font-size: 15px;">
                {{ start_date }}-{{end_date}}，贵我双方销售，回款及开票情况如下，请予确认。
            </div>
        </el-col>
        <el-col :span="24" style="padding: 0 20px">
            <el-table border :data="list" class="bill_detail"
            :header-cell-class-name="cellClass"
            :header-cell-style='{background:"#1890ff",color:"#fff"}'
                    >
                <el-table-column label="上期余款（元）" align="center" prop="lastCycleBalance">

                </el-table-column>
                <el-table-column label="本期提货量（吨）" align="center" prop="netWeightTotal">

                </el-table-column>
                <el-table-column label="本期销售金额（元）" align="center" prop="spendTotal">

                </el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="colsemoney">


                </el-table-column>
                <el-table-column label="本期收款（元）" align="center" prop="paymentTotal">

                </el-table-column>
                <el-table-column label="本期余款（元）" align="center" prop="thisCycleBalance">

                </el-table-column>

            </el-table>
            <div v-show="discounts.length>0">
                <div v-for="(item,index) in discounts" :Key="index" style="margin:10px 0;font-weight:bold;">优惠条件:本期总提货量达到{{item.conditionNum}}吨,结算单价优惠{{item.cutPrice}}元/吨</div>
                <div>备注:本期提货量已满足协商优惠条件,共优惠{{discountTotal}}元计入本期余额</div>
            </div>
        </el-col>

        <!-- 对账单明细表 -->
        <el-col :span="24"  v-if="orders.length>0">
            <div class="table-title" style="margin: 3% 0 1% 0;">
                <div style="display: flex;align-items: center;">
                    <span class="bill_title">磅单列表</span>
                </div>
            </div>
        </el-col>
        <el-col :span="24" style="padding: 0 20px" v-if="orders.length>0">
            <el-table border :data="orders" class="bill_detail"
            :header-cell-class-name="cellClass"
            :header-cell-style='{background:"#1890ff",color:"#fff"}'
                    >
                <el-table-column label="时间" width="100" align="center" prop="endTime" :formatter="formatDate">

                </el-table-column>
                <el-table-column label="磅单号" width="135" align="center" prop="poundSn">

                </el-table-column>
                <el-table-column label="收货单位" width="180" align="center" prop="comName">

                </el-table-column>
                <el-table-column label="主车号" align="center" prop="plateNumber">

                </el-table-column>
                <el-table-column label="挂车号" align="center" prop="carriageNumber">

                </el-table-column>
                <el-table-column label="皮重" align="center" prop="firstWeight">

                </el-table-column>
                <el-table-column label="毛重" align="center" prop="secondWeight">

                </el-table-column>
                <el-table-column label="净重" align="center" prop="netWeight">

                </el-table-column>
                <el-table-column label="单价" align="center" prop="tradingPrice">
                    <template slot-scope="scope">
                        {{scope.row.tradingPrice==null? '' : parseNums(scope.row.tradingPrice)}}
                    </template>
                </el-table-column>
                <el-table-column label="总价" align="center">
                    <template slot-scope="scope">
                        {{scope.row.totalPrice==null?'' : parseNums(scope.row.totalPrice)}}
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
        <!-- <el-col :span="24" class="bill_title">
            {{info.title}}
        </el-col>
        <el-col :span="17">
            <el-row>
                <el-col :span="12" style="padding: 0 20px">
                    对账时间: {{ start_date }}-{{end_date}}
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="24" style="padding: 0 20px">
            <el-table border :data="list" class="bill_detail" :span-method="arraySpanMethod" :row-class-name="tableRowClassName">
                <el-table-column label="卸货明细" align="center">
                    <el-table-column label="序号" align="center" width="50" prop="id">

                    </el-table-column>
                    <el-table-column label="装货日期" align="center" prop="date">

                    </el-table-column>
                    <el-table-column label="装货地" align="center" prop="zh_address">

                    </el-table-column>
                    <el-table-column label="车号" align="center" prop="platterNumber">

                    </el-table-column>
                    <el-table-column label="结算数量(吨)" align="center" prop="weight">

                    </el-table-column>
                    <el-table-column label="单价(元)" align="right" header-align="center" prop="price">

                    </el-table-column>
                    <el-table-column label="其他费用(元)" align="center" prop="other">

                    </el-table-column>
                    <el-table-column label="金额(元)" align="right" header-align="center" prop="amount">

                    </el-table-column>
                </el-table-column>
                <el-table-column label="税率" align="center" width="50" prop="shui">

                </el-table-column>
                <el-table-column label="收款金额" align="center">
                    <el-table-column label="金额(元)" align="right" header-align="center" prop="up_money">

                    </el-table-column>
                    <el-table-column label="收款类型" align="center" prop="type">

                    </el-table-column>
                </el-table-column>
                <el-table-column label="收款日期" align="center">
                    <el-table-column label="上期余额" align="center" prop="money_date">

                    </el-table-column>
                </el-table-column>
                <el-table-column label="余额" align="center">
                    <el-table-column :label="last_money" align="right" header-align="right" prop="balance">

                    </el-table-column>
                </el-table-column>
            </el-table>
            <el-row style="margin-top: 10px">
                <el-col :span="12">
                    <div class="list_item">卖方: {{sale.comName}}（盖章确认）</div>
                    <div class="list_item">卖方对帐负责人: {{sale.name}}</div>
                    <div class="list_item">卖方对帐负责人电话: {{sale.mobile}}</div>
                    <div class="list_item">对帐日期: {{sale.date}}</div>
                    <div class="list_item">邮箱: {{sale.email}}</div>
                </el-col>
                <el-col :span="12">
                    <div class="list_item">买方: 鄂尔多斯市德运物流有限公司（盖章确认）</div>
                    <div class="list_item">买方对帐负责人: </div>
                    <div class="list_item">买方对帐负责人电话: </div>
                    <div class="list_item">对帐日期: <span style="display: inline-block;text-align: right;width: 70px">年</span> <span style="display: inline-block;text-align: right;width: 50px">月</span><span style="display: inline-block;text-align: right;width: 50px">日</span></div>
                    <div class="list_item">邮箱: </div>
                </el-col>
            </el-row>
        </el-col> -->
    </el-row>
</template>

<script>

import request from '@/utils/request'

export default {
    name: 'bill_detail',
    props:["data"],
    data(){
        return {
            is_ok:false,
            info:{
                company:{},
                title:""
            },
            start_date:"",
            end_date:"",
            last_money:"",
            sale:{
                comName:"",
                name:"",
                mobile:"",
                email:"",
                date:""
            },
            comName:"",
            list:[],
            orders:[],
            discounts:[],
            discountTotal:''
        }
    },
    methods:{
        arraySpanMethod({ row, column, rowIndex, columnIndex }){
            if(rowIndex == this.list.length - 2){
                if(columnIndex == 0){
                    return [1, 2];
                }else if(columnIndex == 1){
                    return [0, 0];
                }
            }
            if(rowIndex == this.list.length - 1){
                if(columnIndex == 0){
                    return [1,12];
                }else if(columnIndex == 12) {
                    return [1,13];
                }else {
                    return [0,0];
                }
            }
        },
        tableRowClassName({row, rowIndex}){
            if(rowIndex == this.list.length - 2){
                return 'primary-row';
            }else{
                return '';
            }
        },
        //列表字段显示时间格式
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null) {
                return null
            }
            let dt = new Date(data)
                return dt.getFullYear() + '/' + (dt.getMonth() + 1) + '/' + dt.getDate()
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        getData(){
            request.get("finance/account_statement_detail/"+this.data.id).then(res=>{
                let {orders,accStm} = res.data;
                this.end_date = accStm.cycleEndDate;
                this.start_date = accStm.cycleStartDate;
                this.comName = accStm.comName;
                this.discounts=res.data.discounts

                this.discountTotal=accStm.discountTotal
                let item = {
                            lastCycleBalance:this.parseNums(accStm.lastCycleBalance),
                            netWeightTotal:this.parseNums(accStm.netWeightTotal),
                            paymentTotal:this.parseNums(accStm.paymentTotal),
                            colsemoney:this.parseNums((accStm.spendTotal.toFixed(2)-accStm.discountTotal.toFixed(2)).toFixed(2)),
                            discountTotal:this.parseNums(accStm.discountTotal),
                            spendTotal:this.parseNums(accStm.spendTotal),
                            thisCycleBalance:this.parseNums(accStm.thisCycleBalance),
                        };
                this.list.push(item);
                let ordersData = [];
                orders.map((item) => {
                    item.firstWeight = parseFloat(item.firstWeight).toFixed(2)
                    item.secondWeight = parseFloat(item.secondWeight).toFixed(2)
                    item.netWeight = parseFloat(item.netWeight).toFixed(2)
                    item.realPrice = parseFloat(item.realPrice).toFixed(2)
                    item.tradingPrice = parseFloat(item.tradingPrice).toFixed(2)
                    item.totalPrice = parseFloat(item.totalPrice).toFixed(2)
                    ordersData.push(
                        Object.assign({},item,{comName: this.comName})
                    )
                });
                this.orders=ordersData;
                this.is_ok = true;
            }).catch(err=>{
                this.is_ok = true;
            });
        },
        init(){
            request.get("finance/account_statement/"+this.data.id).then(res=>{
                let {finances,orders,accStm} = res.data;
                let list = [];
                let fee_total = 0;
                this.last_money = accStm.lastCycleBalance.toString();
                this.end_date = accStm.cycleEndDate;
                this.start_date = accStm.cycleStartDate
                this.comName = accStm.comName;
                this.sale.comName = res.data.sellerParty;
                this.info.title = res.data.title;
                this.sale.name = accStm.operName;
                this.sale.mobile = accStm.operMobile;
                this.sale.email = accStm.operEmail;
                this.sale.date = accStm.operTime.split(" ")[0];

                let shuilv = res.data.taxRate;

                if(finances.length > orders.length){
                    for(let i = 0;i<finances.length;i++){
                        let item = {
                            id:i+1,
                            money_date:finances[i].addTime.split(" ")[0],
                            up_money:parseFloat(finances[i].money).toFixed(2).toString(),
                            type:finances[i].type == 0?"预付货款":"优惠抵扣",
                        };
                        if(typeof orders[i] != "undefined"){
                            item.date = orders[i].loadDate.split(" ")[0];
                            item.zh_address = orders[i].loadLocation;
                            item.platterNumber = orders[i].plateNumber;
                            item.weight = parseFloat(orders[i].netWeight).toFixed(2).toString();
                            item.price = parseFloat(orders[i].realPrice).toFixed(2).toString();
                            item.other = parseFloat(orders[i].otherFee).toFixed(2).toString();
                            item.amount = parseFloat(orders[i].realAmount).toFixed(2).toString();
                            item.shui = shuilv;
                            fee_total += orders[i].otherFee;
                        }else{
                            item.date = "";
                            item.zh_address = "";
                            item.platterNumber = "";
                            item.weight = "";
                            item.price = "";
                            item.other = "";
                            item.amount = "";
                            item.shui = "";
                        }
                        list.push(item);
                    }
                }else{
                    for(let i =0;i<orders.length;i++){
                        let item = {
                            id:i+1,
                        };
                        item.date = orders[i].loadDate.split(" ")[0];
                        item.zh_address = orders[i].loadLocation;
                        item.platterNumber = orders[i].plateNumber;
                        item.weight = parseFloat(orders[i].netWeight).toFixed(2).toString();
                        item.price = parseFloat(orders[i].realPrice).toFixed(2).toString();
                        item.other = parseFloat(orders[i].otherFee).toFixed(2).toString();
                        item.amount = parseFloat(orders[i].realAmount).toFixed(2).toString();
                        item.shui = shuilv;
                        fee_total += orders[i].otherFee;
                        if(typeof finances[i] != "undefined"){
                            item.money_date = finances[i].addTime.split(" ")[0];
                            item.up_money = parseFloat(finances[i].money).toFixed(2).toString();
                            item.type = finances[i].type == 0?"预付货款":"优惠抵扣";
                        }else{
                            item.money_date = "";
                            item.up_money = "";
                            item.type = "";
                        }
                        list.push(item);
                    }
                }

                let heji = {
                    id:"合计",
                    date:"",
                    zh_address:"",
                    platterNumber:"",
                    weight:parseFloat(accStm.netWeightTotal).toFixed(2).toString(),
                    price:"",
                    other:parseFloat(fee_total).toFixed(2).toString(),
                    amount:parseFloat(accStm.spendTotal).toFixed(2).toString(),
                    shui:"",
                    up_money:parseFloat(accStm.paymentTotal).toFixed(2).toString(),
                    money_date:"",
                    type:"",
                    balance:parseFloat(accStm.thisCycleBalance).toFixed(2).toString()
                };
                let last = {
                    id:`截止${accStm.cycleEndDate}应收贵公司货款金额（金额为负数是预收货款）：`,
                    date:"",
                    zh_address:"",
                    platterNumber:"",
                    weight:"",
                    price:"",
                    other:"",
                    amount:"",
                    shui:"",
                    up_money:"",
                    money_date:"",
                    type:"",
                    balance:parseFloat(accStm.thisCycleBalance).toFixed(2).toString()
                };
                // list.push(heji);
                // list.push(last);
                this.list = list;
                this.is_ok = true;
            }).catch(err=>{
                this.is_ok = true;
            });
        }
    },
    created() {
        // this.init();
        this.getData();
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.bill_title{
    text-align: center;
    font-size: 25px;
    font-weight: 700;
    margin: 10px 0;
}

.list_item{
    line-height: 1.4em;
}
.table-title_two{
    display: flex;
    justify-content:space-between;
    align-content: center;
}
.table-title{
    display: flex;
    justify-content: center;
    align-content: center;
}
.boxLine{
    background: #797a7b;
    height: 2px;
    width: 96%;
    margin-left: 2%;
}
</style>
